export default function Fclpricing() {
    
    return (
        <><iframe title="FCL Ocean pricing" width="1024" height="1060" src="https://app.powerbi.com/view?r=eyJrIjoiYzU4YmIwZjItNTdhMi00YjJiLTk1N2MtZjc0NjAwYmY3NTFkIiwidCI6ImFjMTA2NGQ4LTcyNjgtNGI1NC05ZjBlLTY3YjU3ODE2MjA0MiJ9" frameborder="0" allowFullScreen="true"></iframe></>
    )
}